import constants from '../constants/constants';
import axiosInstance from './api.service'

const endpointOrigin = "User/";

const Authenticate = async (model) => await axiosInstance.post(endpointOrigin + 'Authenticate', model, {
    requestHandlerEnabled: false,
    responseHandlerEnabled: true
})

const ForgotPassword = async (username) => await axiosInstance.post(endpointOrigin + `ForgotPassword?username=${username}`, {}, {
    requestHandlerEnabled: false,
    responseHandlerEnabled: true
})

const GetAll = async (companyId) => await axiosInstance.get(endpointOrigin + `GetAll?companyId=${companyId}`, constants.REQUIRE_INTERCEPTORS)

const Get = async (id) => await axiosInstance.get(endpointOrigin + `?id=${id}`, constants.REQUIRE_INTERCEPTORS)

const Check = async (username) => await axiosInstance.get(endpointOrigin + `Check?username=${username}`, constants.REQUIRE_INTERCEPTORS)

const Save = async (model) => await axiosInstance.post(endpointOrigin + 'Save', model, constants.REQUIRE_INTERCEPTORS)

const SubmitUserClientList = async (model) => await axiosInstance.post(endpointOrigin + 'SubmitUserClientList', model, constants.REQUIRE_INTERCEPTORS)

const GetUserClientList = async (id) => await axiosInstance.get(endpointOrigin + `GetUserClientList?id=${id}`, constants.REQUIRE_INTERCEPTORS)

const RemoveUserClientList = async (id) => await axiosInstance.get(endpointOrigin + `RemoveUserClientList?id=${id}`, constants.REQUIRE_INTERCEPTORS)

const GetUsersClientList = async (userId) => await axiosInstance.get(endpointOrigin + `GetUsersClientList?userId=${userId}`, constants.REQUIRE_INTERCEPTORS)

const UpdateUsersClientList = async (clients) => await axiosInstance.post(endpointOrigin + 'UpdateUsersClientList', clients, constants.REQUIRE_INTERCEPTORS)

const GetUserClientListAudits = async (userClientListId) => await axiosInstance.get(endpointOrigin + `GetUserClientListAudits?userClientListId=${userClientListId}`, constants.REQUIRE_INTERCEPTORS)

const UpdatePassword = async (userId, password) => await axiosInstance.get(endpointOrigin + `UpdatePassword?id=${userId}&password=${password}`, constants.REQUIRE_INTERCEPTORS)

export {
    Authenticate,
    ForgotPassword,
    GetAll,
    Get,
    Check,
    Save,
    GetUserClientList,
    SubmitUserClientList,
    RemoveUserClientList,
    GetUsersClientList,
    UpdateUsersClientList,
    GetUserClientListAudits,
    UpdatePassword
}